import { render, staticRenderFns } from "./Casette.vue?vue&type=template&id=49c2d1e7&"
import script from "./Casette.vue?vue&type=script&lang=js&"
export * from "./Casette.vue?vue&type=script&lang=js&"
import style0 from "./Casette.vue?vue&type=style&index=0&id=49c2d1e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QInput,QIcon,QTable,QTd,QAvatar});
